let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("gN4dl")]).then(() => parcelRequire('2WNCY'));